import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './SummaryItem.module.sass';
import currency from 'currency.js';

const SummaryItem = ({ text, value, classes, useMinus = false }) => (
  <div className={cn(styles.item, classes)}>
    <div>{text}</div>
    <div>{typeof value === 'number' ? <span>{`${useMinus ? '-' : ''}${currency(value).format()}`}</span> : value}</div>
  </div>
);

SummaryItem.propTypes = {
  text: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  classes: PropTypes.string,
};

export default SummaryItem;
